/** After the cursor leaves the connected bar, how long it waits before flying into the chip. */
export const CALL_BAR_HOVER_LEAVE_DELAY_MS = 800;
